export default class Footer extends React.PureComponent {
  static defaultProps = {
    year: new Date().getFullYear(),
  };

  render() {
    const { year } = this.props;

    return (
      <div className="Login-Footer">
        <div className="Edocat-Info">
          <div>
            <a href="http://www.edocat.cz" target="edocat">
              eDoCat
            </a>{' '}
            &copy; 2011-{year} <a href="http://www.onlio.com">Onlio, a.s.</a>
          </div>
          <div>version {window.Edocat.texts['edocat.version']}</div>
        </div>
        <div className="Alfresco-Info">
          <div>
            Alfresco Community Edition &copy; {year}{' '}
            <a href="https://www.alfresco.com" target="alfresco">
              Alfresco Software, Inc.
            </a>
          </div>
          <div>version v{window.Edocat.texts['edocat.footer.implementation']}</div>
        </div>
      </div>
    );
  }
}
